// extracted by mini-css-extract-plugin
module.exports = {"columns":"fLS1qeY4T4AOT8cIIOeq","content":"ILgjJWcRUy4zwGq9PSnv"};